import React from 'react'

import {IconHeart} from '@components/Icon'

const Footer = () => {
  return (
    <footer className='DemoDetail__footer'>
      <div className='container'>
        <p>
          &copy;{new Date().getFullYear()} <strong>Data Wow Co., Ltd.</strong>{' '}
          All Rights Reserved.
        </p>

        <div className='DemoDetail__footer__space'></div>

        <nav>
          {/* <a href='' title='Terms of Use'>
            Terms of Use
          </a> */}
          <a href='/policy' title='Privacy Policy'>
            Privacy Policy
          </a>
        </nav>
        <p>
          Made with <IconHeart /> in Bangkok
        </p>
      </div>
    </footer>
  )
}

export default Footer
